export type PublicRuntimeConfigKey =
    | 'APP_BUILD_ID'
    | 'VITE_API_URL'
    | 'VITE_API_BASE_URL'
    | 'VITE_API_MULTIPLE_URL'
    | 'TIANDITU_BROWSER_TOKEN'
    | 'VITE_TIANDITU_TK'

export type PublicRuntimeConfig = Partial<Record<PublicRuntimeConfigKey, string>>

interface ReadPublicConfigOptions {
    fallbackToBuildTimeOnEmpty?: boolean
}

type RuntimeConfigWindow = Window & {
    __YOLOPEST_RUNTIME_CONFIG__?: PublicRuntimeConfig
}

const hasOwnProperty = Object.prototype.hasOwnProperty

const trimConfigValue = (value?: string): string => value?.trim() ?? ''

const getRuntimeConfig = (): PublicRuntimeConfig | null => {
    if (typeof window === 'undefined') {
        return null
    }

    return (
        (window as RuntimeConfigWindow).__YOLOPEST_RUNTIME_CONFIG__ ?? null
    )
}

const readBuildTimeConfigValue = (key: PublicRuntimeConfigKey): string => {
    const buildTimeEnv =
        import.meta.env as Partial<Record<PublicRuntimeConfigKey, string>>

    return trimConfigValue(buildTimeEnv[key])
}

export const readPublicConfigValue = (
    key: PublicRuntimeConfigKey,
    options: ReadPublicConfigOptions = {}
): string => {
    const runtimeConfig = getRuntimeConfig()

    if (runtimeConfig && hasOwnProperty.call(runtimeConfig, key)) {
        const runtimeValue = trimConfigValue(runtimeConfig[key])
        if (runtimeValue || !options.fallbackToBuildTimeOnEmpty) {
            return runtimeValue
        }
    }

    return readBuildTimeConfigValue(key)
}

export const readTiandituPublicToken = (): string =>
    readPublicConfigValue('TIANDITU_BROWSER_TOKEN', {
        fallbackToBuildTimeOnEmpty: true,
    }) ||
    readPublicConfigValue('VITE_TIANDITU_TK', {
        fallbackToBuildTimeOnEmpty: true,
    })

export const readRuntimeAppBuildId = (): string =>
    readPublicConfigValue('APP_BUILD_ID')
